import { CropConfiguration } from "@/types/cropConfiguration";
import { PlantingPlan } from "@/types/cropPlan";
import dayjs from "dayjs";

function PlantingMetadata({
    plantingPlan,
    selectedCropConfiguration,
}: {
    plantingPlan?: PlantingPlan;
    selectedCropConfiguration?: CropConfiguration;
}) {
    return (
        <div className="flex flex-row gap-4 text-sm text-default-600">
            {plantingPlan && (
                <>
                    {selectedCropConfiguration?.crop_name && (
                        <div>
                            <span className="font-semibold">Crop: </span>
                            {selectedCropConfiguration?.crop_name}
                        </div>
                    )}
                    {plantingPlan.date && (
                        <div>
                            <span className="font-semibold">Date: </span>
                            {dayjs(plantingPlan.date).format("MMM D, YYYY")}
                        </div>
                    )}
                    {plantingPlan.varieties?.[0]?.crm && (
                        <div>
                            <span className="font-semibold">CRM: </span>
                            {plantingPlan.varieties[0].crm}
                        </div>
                    )}
                    {plantingPlan.seeding_rate && (
                        <div>
                            <span className="font-semibold">
                                Seeding Rate:{" "}
                            </span>
                            {plantingPlan.seeding_rate.toLocaleString()}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default PlantingMetadata;
